import { createPlayerManagerStore } from '@tunein/web-player-manager/react';
import type { StateCreator } from 'zustand';

export interface PlayerState {
  popout: {
    showButton?: boolean;
    isDialogOpen?: boolean;
    externalUrl?: string;
  };
  showVolumeBar: boolean;
}

export interface PlayerActions {
  setPopoutState: (popoutState: PlayerState['popout']) => void;
  setShowVolumeBar: (showVolumeBar: boolean) => void;
}

export type PlayerStore = PlayerState & PlayerActions;
export type InitialPlayerState = Partial<PlayerState>;

const defaultState: PlayerState = {
  popout: {
    showButton: false,
    isDialogOpen: false,
    externalUrl: '',
  },
  showVolumeBar: false,
};

export function createPlayerStore(initialState: InitialPlayerState = {}) {
  const extraStateCreator: StateCreator<PlayerStore> = (set) => ({
    ...defaultState,
    ...initialState,

    setPopoutState: (popout: PlayerState['popout']) =>
      set((prevState) => ({ popout: { ...prevState.popout, ...popout } })),
    setShowVolumeBar: (showVolumeBar: boolean) => set({ showVolumeBar }),
  });

  return createPlayerManagerStore<PlayerStore>(extraStateCreator);
}
